import CalculatorStandardInput from '../../../calculatorInputs/CalculatorStandardInput';
import i18next from 'i18next';
import React from 'react';

const ContainsValue = ({ fieldName, showLabel, readOnly = false }) => {
  return (
    <CalculatorStandardInput
      fieldName={`${fieldName}.${0}`}
      isRequired
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      placeholder={i18next.t(
        `calculator.dialog.create.placeholder.indicateValue`
      )}
      uxVariant="criteriaInput"
      variant="standard"
      validate={() => null}
      triggerOnContinue
      disabled={readOnly}
    />
  );
};

export default ContainsValue;
